import React, {Component} from 'react';
import './index.scss';
import * as messages from '../../../shared/messages';
import {BannerTemplate} from "./CommonComponents";
import Moment from "moment";

class SpCertificateMessage extends Component {

    handleReplaceMetadata = () => {
        this.props.handleReplaceMetadata();
    }

    render() {
        let expirationDate = Moment.utc(this.props.expirationDate).format("DD-MMM-YYYY");
        return (
            (this.props.messageType) ? (
                {
                    "Info":
                        <BannerTemplate bannerStyle={"info-banner"}>
                            <InfoBanner expirationDate={expirationDate}
                                        handleReplaceMetadata={this.handleReplaceMetadata}/>
                        </BannerTemplate>,
                    "Warning":
                        <BannerTemplate bannerStyle={"warning-banner"}>
                            <WarningBanner expirationDate={expirationDate}
                                           handleReplaceMetadata={this.handleReplaceMetadata}/>
                        </BannerTemplate>,
                }[this.props.messageType] || null
            ) : null
        );
    }
}

function InfoBanner(props) {
    return(
        <div>
            {messages.SP_CERTIFICATE_EXPIRES.replace("expirationDate",props.expirationDate)}
            <a role="button"
                id="certificateBannerReplaceSpMetadataButton"
                className="btn btn-link link-button"
                onClick={props.handleReplaceMetadata}
            >{messages.REPLACE_METADATA}
            </a>
            {messages.REPLACE_METADATA_TO_UPDATE_CERTIFICATE}
        </div>
    );
}

function WarningBanner(props) {
    return (
        <div>
            {messages.SP_CERTIFICATE_EXPIRED.replace("expirationDate", props.expirationDate)}
            <a role="button"
                id="certificateBannerReplaceSpMetadataButton"
                className="btn btn-link link-button"
                onClick={props.handleReplaceMetadata}
            >{messages.REPLACE_METADATA}
            </a>
            {messages.REPLACE_METADATA_TO_UPDATE_CERTIFICATE}
        </div>
    );
}

export default SpCertificateMessage;